module.exports = __webpack_public_path__ + "static/media/profile.422855ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/ServiceIcons/profile.svg
// module id = 1211
// module chunks = 0